import type { ApiClient } from "./apiClient";

let _api: ApiClient | null = null;

export function initApiClient(api: ApiClient) {
  _api = api;
}

export function getApiClient(): ApiClient {
  if (!_api)
    throw new Error(
      "API client not initialized. Call initApiClient(api) at app startup."
    );
  return _api;
}

export function resetApiClientForTests() {
  _api = null;
}
